import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { Star, Verified, Support } from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';

const Hero: React.FC = () => {
  const heroTexts = [
    { title: 'Premium Sofas at 50% OFF - Direct from Manufacturer', subtitle: 'Experience luxury with our handcrafted sofas made from world-class materials. Same quality, half the price!' },
    { title: 'Custom Designs Tailored to Your Vision', subtitle: 'Create your dream furniture with our elegant customization services. Every piece crafted to perfection.' },
    { title: 'World-Class Materials & Craftsmanship', subtitle: 'We use only the finest materials sourced globally. Premium quality that stands the test of time.' },
    { title: 'Eco-Friendly & Sustainable Designs', subtitle: 'Environmental-conscious furniture for modern homes. Beautiful designs that care for our planet.' },
    { title: 'Perfect for Homes & Commercial Spaces', subtitle: 'From cozy homes to elegant offices and hotels. Versatile designs for every space and style.' },
  ];

  const heroImages = [
    { src: '/images/furniture/Elite L-shape sofa.png', category: 'Sofa' },
    { src: '/images/furniture/Luxury U-type sofa.jpeg', category: 'Sofa' },
    { src: '/images/furniture/Designer panel bed.jpeg', category: 'Bed' },
    { src: '/images/furniture/Aura Luxe Bed.png', category: 'Bed' },
    { src: '/images/furniture/Elite confort Recliner.jpeg', category: 'Recliner' },
    { src: '/images/furniture/Luxury recliner chair.png', category: 'Recliner' },
    { src: '/images/furniture/Designer Armchair.png', category: 'Chair' },
    { src: '/images/furniture/Scallop lounge chair.png', category: 'Chair' },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroTexts.length);
      setImageIndex((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const features = [
    { image: '/images/pictorial.png', title: 'Flat 50% OFF', description: 'Direct manufacturer pricing - Save big!' },
    { image: '/images/bulk-orders.png', title: 'Bulk Orders', description: 'Wholesale rates for Aditya Birla, Reliance, METRO Cash & Carry, Future Group' },
    { image: '/images/custom-design.png', title: 'Custom Design', description: 'Elegant customization available' },
  ];

  return (
    <Box id="home" sx={{ position: 'relative', overflow: 'hidden' }}>
      <Box sx={{ minHeight: '100vh', paddingTop: { xs: '58px', sm: '62px' }, background: '#FFF8F0', display: 'flex', alignItems: 'center', position: 'relative', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundImage: 'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.05"%3E%3Ccircle cx="30" cy="30" r="4"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' } }}>
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
                <AnimatePresence mode="wait">
                  <motion.div key={currentIndex} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.8 }}>
                    <Typography variant="h1" sx={{ color: '#5C4A3D', fontWeight: 'bold', mb: 2, fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3.5rem' }, textShadow: '0 1px 2px rgba(0,0,0,0.04)', minHeight: { xs: '120px', sm: '140px', md: '160px' } }}>
                      {heroTexts[currentIndex].title}
                    </Typography>
                    <Typography variant="h5" sx={{ color: 'rgba(92,74,61,0.92)', mb: 4, fontWeight: 300, lineHeight: 1.4, fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, minHeight: { xs: '60px', sm: '70px', md: '80px' } }}>
                      {heroTexts[currentIndex].subtitle}
                    </Typography>
                  </motion.div>
                </AnimatePresence>
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                  <Button variant="contained" size="large" href="#products" className="btn-hover" sx={{ backgroundColor: '#8B7355', color: 'white', px: 4, py: 1.5, fontSize: '1.1rem', fontWeight: 'bold', '&:hover': { backgroundColor: 'rgba(139,115,85,0.9)' } }}>
                    Shop Now
                  </Button>
                  <Button variant="outlined" size="large" href="https://wa.me/916309561983?text=Hello%20Ahmed%20Concept%20Sofas!%20I'm%20interested%20in%20your%20premium%20furniture.%20I%20would%20like%20to%20know%20more%20about%20your%20products%20and%20pricing." target="_blank" className="btn-hover" sx={{ borderColor: '#8B7355', color: '#8B7355', borderWidth: 2, px: 4, py: 1.5, fontSize: '1.1rem', fontWeight: 'bold', '&:hover': { borderWidth: 2, borderColor: '#8B7355', backgroundColor: 'rgba(139,115,85,0.08)' } }}>
                    Order on WhatsApp
                  </Button>
                </Box>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ position: 'relative', height: { xs: 300, md: 500 } }}>
                <AnimatePresence mode="wait">
                  <motion.div key={imageIndex} initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 1.1 }} transition={{ duration: 0.8 }} style={{ position: 'absolute', width: '100%', height: '100%' }}>
                    <Box component="img" src={heroImages[imageIndex].src} alt={heroImages[imageIndex].category} sx={{ width: '100%', height: '100%', borderRadius: 4, objectFit: 'cover', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', border: '3px solid rgba(255,255,255,0.3)' }} />
                  </motion.div>
                </AnimatePresence>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, sm: 3 } }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' }, gap: { xs: 3, md: 4 } }}>
          {features.map((feature, index) => (
            <motion.div key={index} initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: index * 0.1 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', borderRadius: 2, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', transition: 'all 0.3s ease', '&:hover': { transform: 'translateY(-5px)', boxShadow: '0 4px 16px rgba(0,0,0,0.12)' }, height: '100%' }}>
                <Box sx={{ width: '100%', height: 250, overflow: 'hidden', backgroundColor: 'rgba(139,115,85,0.08)' }}>
                  <Box component="img" src={feature.image} alt={feature.title} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </Box>
                <Box sx={{ p: 3, textAlign: 'center', backgroundColor: 'rgba(255,255,255,0.8)', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold', fontSize: { xs: '1.1rem', sm: '1.25rem', md: '1.4rem' }, color: '#8B7355' }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: { xs: '0.85rem', sm: '0.95rem' }, color: 'rgba(139,115,85,0.8)', lineHeight: 1.5 }}>
                    {feature.description}
                  </Typography>
                </Box>
              </Box>
            </motion.div>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;
